// extracted by mini-css-extract-plugin
module.exports = {"BottomContainer":"Frequency_BottomContainer__2E4Yt","ComponentHeader":"Frequency_ComponentHeader__aDs0L","HeaderLeft":"Frequency_HeaderLeft__37Uht"};